/* Cart Drawer Custom Element */

class CartDrawer extends HTMLElement {
  connectedCallback() {
    this.closeButtons = this.querySelectorAll('[data-close]');
    this.closeButtons.forEach(btn => {
      btn.addEventListener('click', () => this.close());
    });

    PubSub.subscribe('cart:open', () => this.open());
    PubSub.subscribe('cart:update', () => this.refresh());

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.classList.contains('is-open')) {
        this.close();
      }
    });
  }

  open() {
    this.classList.add('is-open');
    this.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    this.refresh();
  }

  close() {
    this.classList.remove('is-open');
    this.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
  }

  async refresh() {
    try {
      const html = await fetchHTML(`${window.location.pathname}?section_id=cart-drawer`);
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newBody = doc.getElementById('CartDrawerBody');
      const currentBody = document.getElementById('CartDrawerBody');
      if (newBody && currentBody) {
        currentBody.innerHTML = newBody.innerHTML;
      }

      const newFooter = doc.querySelector('.cart-drawer__footer');
      const currentFooter = this.querySelector('.cart-drawer__footer');
      if (newFooter && currentFooter) {
        currentFooter.innerHTML = newFooter.innerHTML;
      } else if (newFooter && !currentFooter) {
        this.querySelector('.cart-drawer__panel').appendChild(newFooter);
      }
    } catch (error) {
      console.error('Cart drawer refresh error:', error);
    }
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}
